import { ContactBar, ContactAvatar, TContactType } from '@cian/contact-card-component';
import React from 'react';

import { AgentLevelView } from '../../../components/AgentLevelView';
import { BrandingLevelWrapper } from '../../../components/BrandingLevelWrapper';
import { ContactActionsLayout } from '../../../components/ContactActionsLayout';
import { useOfferContext } from '../../../context';
import { AgentBookButtonContainer } from './AgentBookButtonContainer';
import { AgentPhoneButtonContainer } from './AgentPhoneButtonContainer';
import { AgentShowMoreOffersContainer } from './AgentShowMoreOffersContainer';
//TODO: Это надо вернуть попапом в следующей итерации
// import { AgentProofsContainer } from './AgentProofsContainer';
import { AgentWorkHonestlyProofsContainer } from './AgentWorkHonestlyProofsContainer';
import { getAgentLevelInfo } from './AgentWorkHonestlyProofsContainer/utils';
import { ChatButtonContainer } from './ChatButtonContainer';
import { NewbuildingBrokerButtonContainer } from './NewbuildingBrokerButtonContainer';

const AGENT_TYPE_TITLE: {
  [key: string]: string | undefined;
} = {
  managementCompany: 'Ук・оф.Представитель',
  realtor: 'Риелтор',
  agent: 'Агент',
  agency: 'Агентство недвижимости',
  homeowner: 'Собственник',
  builder: 'Застройщик',
  builderRepresentative: 'Представитель застройщика',
  consultant: 'Консультант',
  bank: 'Банк',
};

const AVATAR_TYPE: {
  [key: string]: string | undefined;
} = {
  builderRepresentative: 'builder',
  consultant: 'builder',
  managementCompany: 'agency',
  realtor: 'agent',
};

export function AgentContainer() {
  const offerData = useOfferContext();
  const {
    agentType,
    agentImageLink,
    agentName,
    agentProfileLink,
    offer: { brandingLevel },
  } = offerData;
  const agentLevelInfo = getAgentLevelInfo(offerData);

  const avatarType = (AVATAR_TYPE[agentType] || agentType) as TContactType;

  return (
    <BrandingLevelWrapper brandingLevel={brandingLevel}>
      <ContactBar
        title={AGENT_TYPE_TITLE[agentType] || ''}
        avatar={<ContactAvatar type={avatarType} src={agentImageLink} />}
        name={agentName || ''}
        href={agentProfileLink}
        nameIcons={agentLevelInfo && <AgentLevelView agentLevelInfo={agentLevelInfo} />}
        labels={<AgentWorkHonestlyProofsContainer />}
        actions={
          <ContactActionsLayout
            showMoreOffersLink={<AgentShowMoreOffersContainer />}
            chatButton={<ChatButtonContainer />}
            brokerButton={<NewbuildingBrokerButtonContainer />}
            phoneButton={<AgentPhoneButtonContainer />}
            bookButton={<AgentBookButtonContainer />}
          />
        }
      />
    </BrandingLevelWrapper>
  );
}
